<template>
  <div class="relative">
    <button ref="dropdownTrigger" @click="toggleDropdown"
      class="flex items-center hover:opacity-80 transition-opacity cursor-pointer">
      <Globe class="w-6 h-6 text-primary" />
    </button>

    <!-- 下拉選單 -->
    <div v-if="isOpen" ref="dropdownMenu"
      class="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg py-1 z-50">
      <button v-for="locale in localeItems" :key="locale.value"
        @click="handleLocaleChange(locale.value)"
        class="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700">
        {{ locale.label }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Globe } from 'lucide-vue-next';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useI18nLocale } from '~/composables/useI18nLocale';
import type { LocaleType } from '~/composables/useI18nLocale';

interface LocaleItem {
  label: string;
  value: LocaleType;
}

const isOpen = ref(false);
const dropdownTrigger = ref<HTMLElement | null>(null);
const dropdownMenu = ref<HTMLElement | null>(null);
const { changeLocale } = useI18nLocale();

const localeItems = computed<LocaleItem[]>(() => [
  { label: 'English', value: 'en' },
  { label: '中文', value: 'zh-TW' },
]);

async function handleLocaleChange(newValue: LocaleType) {
  await changeLocale(newValue);
  isOpen.value = false;
}

function toggleDropdown() {
  isOpen.value = !isOpen.value;
}

function handleClickOutside(event: MouseEvent) {
  const target = event.target as HTMLElement;
  if (!dropdownMenu.value?.contains(target) && !dropdownTrigger.value?.contains(target)) {
    isOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script> 